module.exports = __webpack_public_path__ + "static/media/profile-bg.e4c5793d.png";